export const BACKEND_URL = "https://api.f2-test.ru";
/* export const BACKEND_URL = 'http://localhost:3001'; */
/* export const BACKEND_URL = 'http://192.168.1.54:3001'; */
/* export const BACKEND_URL = 'https://api.f2-test.ru'; */

export const AI_SERVER_URL = 'https://robot.lights-on.su';
/* export const AI_SERVER_URL = 'https://robot.f2-test.su'; */

export const cameras = [
  {id: 'phone', name: 'Телефон', src: ''},
  {id: 'camera1', name: 'Камера наружного наблюдения 1', src: ''},
  {id: 'camera2', name: 'Камера наружного наблюдения 2', src: ''},
  {id: 'camera3', name: 'Камера наружного наблюдения 3', src: 'https://cam-world.ru/russia/bijsk/bijsk-pontonnyj-most/'},
  /* 
  {id: "camera4", name: "Камера 4", src: "https://cam-world.ru/russia/bijsk/bijsk-pontonnyj-most/"},
  {id: "camera5", name: "Камера 5", src: "https://cam-world.ru/russia/bijsk/bijsk-pontonnyj-most/"},
  {id: "camera6", name: "Камера 6", src: "https://cam-world.ru/russia/bijsk/bijsk-pontonnyj-most/"},
  {id: "camera7", name: "Камера 7", src: "https://cam-world.ru/russia/bijsk/bijsk-pontonnyj-most/"},
  {id: "camera8", name: "Камера 8", src: "https://cam-world.ru/russia/bijsk/bijsk-pontonnyj-most/"},
  {id: "camera9", name: "Камера 9", src: "https://cam-world.ru/russia/bijsk/bijsk-pontonnyj-most/"}, 
  */
];

export const MAX_IMAGE_SIZE = 2048;
export const IMAGE_QUALITY = 1;

/* fix: global settings */
